import { Team__Llamas } from "../teams/Llamas";
import { Team__Grizzlies } from "../teams/Grizzlies";
import { Team__PecanBros } from "../teams/PecanBros";
import { Team__Joeles } from "../teams/Joeles";
import { Team__Adrianes } from "../teams/Adrianes";
import { Team__FlintTropics } from "../teams/FlintTropics";
import { Team__Natalias } from "../teams/Natalias";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Llamas = {
  team: Team__Llamas,
  playingPlayers: [],

  goals: 58,
  penaltyGoals: 0,
  isWinner: false,
};

const Grizzlies = {
  team: Team__Grizzlies,
  playingPlayers: [],

  goals: 21,
  penaltyGoals: 0,
  isWinner: false,
};

const PecanBros = {
  team: Team__PecanBros,
  playingPlayers: [],

  goals: 28,
  penaltyGoals: 0,
  isWinner: false,
};

const Joeles = {
  team: Team__Joeles,
  playingPlayers: [],

  goals: 24,
  penaltyGoals: 0,
  isWinner: false,
};

const Adrianes = {
  team: Team__Adrianes,
  playingPlayers: [],

  goals: 13,
  penaltyGoals: 0,
  isWinner: false,
};

const FlintTropics = {
  team: Team__FlintTropics,
  playingPlayers: [],

  goals: 39,
  penaltyGoals: 0,
  isWinner: false,
};

const Natalias = {
  team: Team__Natalias,
  playingPlayers: [],

  goals: 32,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada4 = {
  jornadaPosition: 4,
  matches: [
    {
      team1: Llamas,
      team2: Grizzlies,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: PecanBros,
      team2: Joeles,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "13:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Adrianes,
      team2: FlintTropics,

      isCompleted: true,
      isPlaying: false,
      day: "Jueves",
      date: "2026-07-30",
      time: "14:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: Natalias,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: true,
      day: "Jueves",
      date: "2026-07-30",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    }
  ],
};
